import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

function SearchFilter({ searchTerm, onSearchChange }) {
  return (
      <div className="search-container">
        <label className="control-label">Search Layers</label>
        <div className="input-wrapper">
          <FaSearch className="search-icon" />
          <input 
            type="text"
            className="search-input"
            placeholder="Search layers (e.g., python 3.9 arm)..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="clear-search-btn"
              onClick={() => onSearchChange('')}
              title="Clear search"
            >
              <FaTimes />
            </button>
          )}
        </div>
      </div>
  );
}

export default SearchFilter;
